import { formatMessageDate } from '@/lib/utils';
function ChatDate({
  date
}: {
  date: string;
}) {
  return <div className="text-xs text-foreground/50 pb-4 mx-auto" data-sentry-component="ChatDate" data-sentry-source-file="date.tsx">{formatMessageDate(date)}</div>;
}
export default ChatDate;